'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function AEFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("path", { id: "mantine-cpjwmojav", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("mask", { id: "mantine-9nwgtse72", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { xlinkHref: "#mantine-cpjwmojav" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#mantine-9nwgtse72)" }, /* @__PURE__ */ React.createElement("path", { fill: "#F7FCFF", d: "M0 0h32v24H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#5EAA22", d: "M0 0h32v8H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#272727", d: "M0 16h32v8H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#E31D1C", d: "M0 0h10v24H0z" }))))
  );
}

export { AEFlag };
//# sourceMappingURL=AE.mjs.map
